import { useState } from "react";
import { Alert, Button, Grid, Modal, Snackbar, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { request } from "@/Api";
import { CustomBox } from "@/common/StyledComponents";
import {
    cancelConfirmingRefutedBillLine,
    selectConfirmingRefutedBillLine,
} from "./actualSlice";
import { updateBillLine } from "./actualSlice";

export default function AccountingBillLineRefutalConfirmationPopup({
    getProject,
}) {
    const [snackBarMessage, setSnackBarMessage] = useState(null);
    const dispatch = useDispatch();
    const confirmingRefutedBillLine = useSelector(
        selectConfirmingRefutedBillLine,
    );
    const theme = useTheme();

    const handleClose = () => {
        dispatch(cancelConfirmingRefutedBillLine());
    };

    const handleResolve = () => {
        request
            .post(
                `accounting-bills/${confirmingRefutedBillLine.id}/resolve-refutal`,
            )
            .then((response) => {
                dispatch(updateBillLine(response.data));
                setSnackBarMessage("Bill refutal resolved");
                handleClose();
                getProject();
            });
    };

    return (
        <>
            {confirmingRefutedBillLine && (
                <Modal
                    onClose={handleClose}
                    open={confirmingRefutedBillLine != null}
                >
                    <CustomBox
                        sx={{
                            background: theme.palette.background.default,
                            padding: 4,
                        }}
                    >
                        <Grid container alignItems={"center"} spacing={3}>
                            <Grid item>
                                <h1>Restore refuted bill</h1>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <p>{`${confirmingRefutedBillLine.vendor_name} ${confirmingRefutedBillLine.accounting_bill_number}`}</p>
                        </Grid>

                        <Grid container spacing={2} justifyContent={"right"}>
                            <Grid item>
                                <Button color="secondary" onClick={handleClose}>
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button color="success" onClick={handleResolve}>
                                    Restore
                                </Button>
                            </Grid>
                        </Grid>
                    </CustomBox>
                </Modal>
            )}

            <Snackbar
                open={snackBarMessage != null}
                autoHideDuration={2000}
                onClose={() => {
                    setSnackBarMessage(null);
                }}
            >
                <Alert severity="success">{snackBarMessage}</Alert>
            </Snackbar>
        </>
    );
}
